<h3 *ngIf="!scannerStarted">Bezig met openen van camera</h3>
<app-scanner id="scanner" (scanSuccess)="onScanSuccess($event)" (started)="onStarted($event)" [type]="['code_128']"></app-scanner>
